import { useState, useEffect } from 'react';
import { ISliderSettings } from 'View/HookApi/useSliderSettings';
import { breakpoints } from 'View/Theme';

export type ITestimonialSliderSettings = ISliderSettings;

export const useTestimonialSliderSettings = (totalCount: number): ITestimonialSliderSettings => {
  const [settings, setSettings] = useState<ITestimonialSliderSettings>({} as ITestimonialSliderSettings);

  useEffect(() => {
    const baseSettings: ITestimonialSliderSettings = {
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      speed: 800,
      autoplaySpeed: 5000,
      variableWidth: true,
      centerMode: false,
      initialSlide: 1,
      centerPadding: '0px',
      swipe: true,
      accessibility: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      arrows: false,
    };

    const responsive: ITestimonialSliderSettings['responsive'] = [
      {
        breakpoint: parseInt(breakpoints.xl, 10),
        settings: {
          ...baseSettings,
          arrows: true,
        },
      },
      {
        breakpoint: parseInt(breakpoints.lg, 10),
        settings: {
          ...baseSettings,
          arrows: true,
        },
      },
      {
        breakpoint: parseInt(breakpoints.md, 10),
        settings: {
          ...baseSettings,
          centerMode: false,
          variableWidth: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false,
          initialSlide: 1,
        },
      },
      {
        breakpoint: parseInt(breakpoints.sm, 10),
        settings: {
          ...baseSettings,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true,
          centerPadding: '60px',
          arrows: false,
        },
      },
    ];

    setSettings({
      ...baseSettings,
      responsive,
    });
  }, [totalCount]);

  return settings;
};
